import FooterMusci from '@/components/MusicListItem/FooterMusci.vue';
export default {
  components: {
    FooterMusci
  }
};